"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFDocumentContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.PDFDocumentContainer = styled_components_1.default.div `
	overflow-y: scroll;
	overflow-x: hidden;
	display: flex;
	justify-content: center;
	height: 100%;
	width: 100%;
	padding: 0 3%;
	${props => props.showGrayBackground &&
    (0, styled_components_1.css) `
			background-color: ${props.theme.color.gray9};
		`}

	.react-pdf__Document {
		width: 100%;
		canvas {
			width: 100% !important;
			height: auto !important;
			margin-bottom: 3%;
		}
		.react-pdf__Page__textContent {
			display: none !important;
		}
		.react-pdf__message {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
`;
